




























import Vue from 'vue'

export default Vue.extend({
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, undefined],
      required: true
    },
    maxNumber: {
      type: [Number, undefined],
      default: undefined
    },
    minNumber: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    restockDate: {
      type: String,
      default: ''
    },
    unpublished: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    placeholder(): string {
      return this.disabled ? '-': '0'
    },
    displayVal(): number | undefined {
      return this.value === 0 ? '' : this.value.toLocaleString()
    }
  },
  methods: {
    onChange(value: number) {
      this.$emit('input', value || 0)
      this.$emit('change', value || 0)
    },
    inputHandler() {
      const halfWidthChar = this.$refs.input.value.replace(/[０-９]/g, s =>
        String.fromCharCode(s.charCodeAt(0) - 65248)
      )
      const numberMatches = halfWidthChar.match(/\d+/g)
      if (numberMatches) {
        const numberValue = Number(numberMatches.join(''))
        this.$refs.input.value = numberValue
        this.onChange(numberValue)
      } else {
         this.$refs.input.value = ''
         this.onChange(0)
      }
    },
    blurHandler() {
      this.$refs.input.value = this.displayVal
    }
  }
})
